const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentCallToAction extends HTMLElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {

		if (this.initialized) {
			return;
		}

		this.contentElement = this.querySelector('.component-call-to-action__content');

		if (this.contentElement) {
			this.contentElement.addEventListener('mouseenter', this.linkHoverIn);
			this.contentElement.addEventListener('focusin', this.linkHoverIn);
			this.contentElement.addEventListener('mouseleave', this.linkHoverOut);
			this.contentElement.addEventListener('focusout', this.linkHoverOut);
		}

		this.initialized = true;

	}

	linkHoverIn = () => {
		this.setAttribute('data-hover', 'true');
	}

	linkHoverOut = () => {
		this.setAttribute('data-hover', 'false');
	}

}

customElements.define('component-call-to-action', ComponentCallToAction, {extends: 'section'});